/// <amd-module name="Feed/Legacy/Types/IUpstreamSettingsRowData" />
import { IVssIconProps } from "VSSUI/VssIcon";

import { UpstreamSource } from "Feed/Common/Contracts/Feed";

import { UpstreamHealthStatus } from "Feed/Common/Contracts/WebPage";

export interface IUpstreamSettingsRowData {
    /**
     * The UpstreamSource associated with the current row
     */
    upstreamSource: UpstreamSource;

    /**
     * The localized type of upstreamSource
     */
    upstreamSourceType: string;

    /**
     * True if upstreamSource is invalid (e.g. protocol disabled/bad protocol)
     */
    isInvalid: boolean;

    /**
     * The icon props associated with upstreamSource's protocol
     */
    iconProps: IVssIconProps;

    /**
     * The standardised name of the upstreamSource's protocol
     */
    protocolName: string;

    /**
     * Health status of the upstream source
     */
    upstreamHealthStatus: UpstreamHealthStatus;
}
